// extracted by mini-css-extract-plugin
module.exports = {"SenceCardC":"SenceCardC_SenceCardC__bjhh4"};